up.compiler(".up_not_below_zero", function (element) {
  function theCallback() {
    if (element.value < 0) {
      element.value = 0;
    }
  }
  element.addEventListener("input", theCallback);
  return () => {
    element.removeEventListener("input", theCallback);
  };
});
